import { render, staticRenderFns } from "./QRLogin.vue?vue&type=template&id=6ed70834&scoped=true&"
import script from "./QRLogin.vue?vue&type=script&lang=js&"
export * from "./QRLogin.vue?vue&type=script&lang=js&"
import style0 from "./QRLogin.vue?vue&type=style&index=0&id=6ed70834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed70834",
  null
  
)

export default component.exports